import React from 'react';
import { Route } from 'react-router-dom';
import { InventoryLibrary } from './Routes';

export const routes = [<Route key={0} path="/inventory-library" component={InventoryLibrary} />];

export const navigation = [
    { name: 'inventory_lib', link: '/inventory-library', match: '/inventory-library', icon: 'Template' },
];
